import { getFunctions, httpsCallable } from 'firebase/functions';

function callBrokerLookup(tenantId, payload) {
  if (!tenantId) return Promise.reject(new Error('tenantId is required'));
  const fn = httpsCallable(getFunctions(), 'manageBrokerInvoiceLookup');
  return fn({ tenantId, ...payload }).then((result) => result.data);
}

export function linkBrokerInvoice(tenantId, { commercialInvoice, jobNumber, source, aliasInvoice }) {
  return callBrokerLookup(tenantId, {
    action: 'link_invoice', commercialInvoice, jobNumber, source, aliasInvoice: aliasInvoice || null,
  });
}

export function upsertBrokerInvoiceBatch(tenantId, records, sourceFile) {
  return callBrokerLookup(tenantId, { action: 'batch_upsert', records, sourceFile });
}

export function ignoreBrokerInvoice(tenantId, commercialInvoice, reason, note) {
  return callBrokerLookup(tenantId, { action: 'ignore', commercialInvoice, reason, note });
}

export function unignoreBrokerInvoice(tenantId, commercialInvoice) {
  return callBrokerLookup(tenantId, { action: 'unignore', commercialInvoice });
}
